import roleSetMap from '@/api/roleSet';
import { post } from '@/common/request';

export interface RoleInfo {
 id?: number;
 name?: string,
 type?: number[]
 typeName?: string,
 multiSelect?: number
}

interface Response {
  pageNum?: number;
  pageSize?: number;
  objectList?: RoleInfo[];
  totalNum?: number;
  meta?: any;
}

class RoleSet {
  getList(params?: any): Promise<Response> {
    return post(roleSetMap.get('list'), { ...params }, { proxyApi: '/resserv', needHint: true });
  }

  updateSingUser(id:number, multiSelect: number) {
    return post(roleSetMap.get('updateSingleUser'), { id, multiSelect }, { proxyApi: '/resserv', needHint: true });
  }

  batch(type: 0 | 1, tenantPlaceIdList: any[], tenantSpotIdList: any[], roleRelationList: any[]) {
    return post(roleSetMap.get('batch'), { type, tenantPlaceIdList, tenantSpotIdList, roleRelationList }, { proxyApi: '/resserv', needHint: true });
  }

  singleBatch(type: 1 | 0, tenantPlaceId: any[], tenantSpotId: any, roleId, employeeIdList: any[]) {
    return post(roleSetMap.get('singleBatch'), { type, tenantPlaceId, tenantSpotId, roleId, employeeIdList }, { proxyApi: '/resserv', needHint: true });
  }

}

export default new RoleSet();
